module.exports = __webpack_public_path__ + "static/media/audiology.b18e2e55.svg";